'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import { terraProxyApiClient } from '../../clients/testerClient';
import { TARGET_TYPE } from '../../utils/target-scope.utils';
import { TARGETS_QUERY_KEY } from '../useTargets';
import { APPLICATION_BY_ID_QUERY_KEY } from './useApplicationById';

export function useDeleteApplicationTarget() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      applicationId,
      targetType,
    }: {
      applicationId: string;
      targetType: TargetTypeType;
    }) =>
      targetType === TARGET_TYPE.AI_APPLICATION
        ? terraProxyApiClient.deleteAiApplicationTarget(applicationId)
        : terraProxyApiClient.deleteApplicationTarget(applicationId),
    onSuccess: async (_result, { applicationId }) => {
      queryClient.removeQueries({
        queryKey: [APPLICATION_BY_ID_QUERY_KEY, applicationId],
      });
      await queryClient.invalidateQueries({ queryKey: [TARGETS_QUERY_KEY] });
    },
  });
}
